import Tether from 'tether'
window.Tether = Tether;